import React, { memo } from 'react';
import { 
  Folder, 
  FolderOpen,
  Home, 
  Download, 
  FileText, 
  Image, 
  Music as MusicIcon,
  Film,
  HardDrive,
  Cloud,
  Star,
  Clock
} from 'lucide-react';

const FilesContent = memo(({ activity }) => {
  const isScrolling = activity?.action === 'scroll';
  const isClicking = activity?.action === 'click';

  const sidebarItems = [
    { icon: Star, label: 'Favorites', color: 'rgba(255, 200, 0, 1)' },
    { icon: Clock, label: 'Recents', color: 'rgba(100, 100, 100, 1)' },
    { icon: Cloud, label: 'iCloud Drive', color: 'rgba(0, 122, 255, 1)' },
    { icon: Home, label: 'Desktop', color: 'rgba(100, 100, 100, 1)' },
    { icon: FileText, label: 'Documents', color: 'rgba(100, 100, 100, 1)' },
    { icon: Download, label: 'Downloads', color: 'rgba(100, 100, 100, 1)' },
  ];

  const folders = [
    { name: 'Projects', icon: '📁', items: 24, color: 'rgba(0, 122, 255, 0.1)' },
    { name: 'Documents', icon: '📄', items: 156, color: 'rgba(52, 199, 89, 0.1)' },
    { name: 'Photos', icon: '🖼️', items: 892, color: 'rgba(255, 149, 0, 0.1)' },
    { name: 'Music', icon: '🎵', items: 342, color: 'rgba(255, 45, 85, 0.1)' },
    { name: 'Videos', icon: '🎬', items: 67, color: 'rgba(175, 82, 222, 0.1)' },
    { name: 'Downloads', icon: '⬇️', items: 45, color: 'rgba(90, 200, 250, 0.1)' }
  ];

  return (
    <div className="finder-content">
      {/* Finder Toolbar */}
      <div className="finder-toolbar">
        <div className="finder-nav-buttons">
          <button className="finder-nav-btn">‹</button>
          <button className="finder-nav-btn">›</button>
        </div>
        <div className="finder-path">
          <span className="path-segment">Documents</span>
        </div>
        <div className="finder-view-options">
          <button className="view-btn active">⊞</button>
          <button className="view-btn">≡</button>
        </div>
      </div>

      <div className="finder-layout">
        {/* Sidebar */}
        <div className="finder-sidebar">
          <div className="sidebar-group">
            <div className="sidebar-group-title">Favorites</div>
            {sidebarItems.map((item, index) => (
              <div 
                key={index} 
                className={`finder-sidebar-item ${index === 3 ? 'active' : ''}`}
              >
                <item.icon size={8} style={{ color: item.color }} />
                <span>{item.label}</span>
              </div>
            ))}
          </div>
          
          <div className="sidebar-group">
            <div className="sidebar-group-title">Devices</div>
            <div className="finder-sidebar-item">
              <HardDrive size={8} style={{ color: 'rgba(100, 100, 100, 1)' }} />
              <span>Macintosh HD</span>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className={`finder-main ${isScrolling ? 'scrolling' : ''}`}>
          <div className="finder-grid">
            {folders.map((folder, index) => (
              <div 
                key={index}
                className={`finder-item ${index === 0 && isClicking ? 'clicking' : ''}`}
              >
                <div className="finder-item-icon" style={{ background: folder.color }}>
                  <span className="folder-emoji">{folder.icon}</span>
                </div>
                <div className="finder-item-info">
                  <div className="finder-item-name">{folder.name}</div>
                  <div className="finder-item-count">{folder.items} items</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Status Bar */}
      <div className="finder-statusbar">
        <span className="status-text">{folders.length} items</span>
      </div>
    </div>
  );
});

FilesContent.displayName = 'FilesContent';

export default FilesContent;
